// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aea58d51","239":"492c545f","455":"dce33508"}[chunkId] + ".chunk.js";
};